interface Props {
  size?: number;
}

export default function EthIcon(props: Props) {
  const { size = 100 } = props;

  return (
    <svg
      width={size}
      height={size}
      css="flex-shrink: 0"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" fill="#627EEA" />
      <path
        d="M49.9945 16.6667V41.3056L70.8195 50.6111L49.9945 16.6667Z"
        fill="white"
        fillOpacity="0.602"
      />
      <path
        d="M49.9944 16.6667L29.1666 50.6111L49.9944 41.3056V16.6667Z"
        fill="white"
      />
      <path
        d="M49.9945 66.5777V83.3194L70.8334 54.4888L49.9945 66.5777Z"
        fill="white"
        fillOpacity="0.602"
      />
      <path
        d="M49.9944 83.3194V66.5749L29.1666 54.4888L49.9944 83.3194Z"
        fill="white"
      />
      <path
        d="M49.9945 62.7027L70.8195 50.611L49.9945 41.311V62.7027Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M29.1666 50.611L49.9944 62.7027V41.311L29.1666 50.611Z"
        fill="white"
        fillOpacity="0.602"
      />
    </svg>
  );
}
